module.exports = __webpack_public_path__ + "static/img/mp3_pause.b97f32d3.png";